module.exports = __webpack_public_path__ + "img/icon-chevron-right.0f52fbc6.svg";